import { render, staticRenderFns } from "./RestoreConfirm.vue?vue&type=template&id=f99715e0&"
import script from "./RestoreConfirm.vue?vue&type=script&lang=js&"
export * from "./RestoreConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports